var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full mb-6"},[_c('div',{staticClass:"help-center-items"},[_c('HelpCenterMenu',{attrs:{"title":_vm.Vue.t('Getting Started'),"items":_vm.getItems()},on:{"menuItemClicked":function($event){return _vm.$parent.$emit(
          'gettingStartedNavItemClicked',
          $event.categorySlug,
          $event.articleSlug,
          $event.label
        )}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }